import React, { Component } from 'react';
import axios from 'axios'
import { serverIp, firebaseAuth, } from '../../../../config/constants.js'
import { OrderCardsTable, TopMenu } from '../DashboardParts';
import * as UiConsts from '../../../../config/UiConstants'
import { checkAdminEmail } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';

export default class ConnectOrder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            phoneNumber: '',
            returnedOrders: []
        }
    }

    componentDidMount() {
        this.setState({
            phoneNumber: this.props.match.params.phoneNumber
        }, this.getConnectedOrders())

        //LOAD USER
        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");


            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }

    getConnectedOrders = () => {
        //NET WORK CALL
        this.setState({
            loading: true
        })
        
        axios.post(serverIp + 'orders/findOrdersByPhone', {
            apiKey: 'asdf@asdfasf',
            phone: this.props.match.params.phoneNumber
        })
            .then((response) => {
                console.log(response.data);
                console.log("findShirtsToTagOrders size:" + response.data.firebaseOrders.length);
                this.setState({
                    returnedOrders: response.data.firebaseOrders,
                    loading: false
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const userEmail = this.state.user && this.state.user.email
        ? <h3>{this.state.user.email}</h3>
        : 'no email'

        const wholeUI = this.state.user && this.state.user.email && this.state.algoliaUser != null && this.state.algoliaUser.isAdmin
            ? <div>

                <TopMenu />
                <h4>PHONE:{this.state.phoneNumber} NUM ORDERS:{this.state.returnedOrders.length}</h4>
                <OrderCardsTable
                    user={this.state.user}
                    orders={this.state.returnedOrders} />

            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (
            this.state.loading === true ? <UiConsts.LoadingComponent /> :
                <div>
                    {wholeUI}
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ConnectedOrders/ConnectOrder.js